// Yeni sistem kullanım kılavuzu (Ana Sayfa'daki video rehber)
const userGuide = {
  card: {
    eyebrow: 'Yeni sistem · Video rehber',
    duration: '{{minutes}} dk',
    title: 'Yeni Portal Kullanım Kılavuzu',
    text: 'Ana Sayfa ve Profil sayfasındaki her şey, adım adım. Bir konu seçin, doğrudan o bölümden izleyin.',
    watch: 'İzlemeye Başla',
    resume: 'Kaldığım Yerden Devam Et',
    restart: 'Baştan izle',
    watched: '{{done}}/{{total}} konu izlendi',
    allWatched: 'Tüm konuları izlediniz',
    topics: 'Sık aranan konular',
    oldGuide: 'Eski sistem kılavuzu (PDF)',
  },
  player: {
    title: 'Yeni Portal Kullanım Kılavuzu',
    subtitle: 'Ana Sayfa ve Profil sayfası · {{count}} konu · {{minutes}} dk',
    searchPlaceholder: 'Konu ara: izin, masraf, şifre...',
    searchLabel: 'Kılavuzda ara',
    noResults: '"{{term}}" ile eşleşen konu bulunamadı. Başka bir kelime deneyin.',
    matchedSteps_one: '{{count}} adım eşleşti',
    matchedSteps_other: '{{count}} adım eşleşti',
    topics: 'Konular',
    steps: 'Bu bölümdeki adımlar',
    stepsHint: 'Bir adıma tıklayın, video o andan oynasın.',
    watched: 'İzlendi',
    nowPlaying: 'Oynatılıyor',
    chapterOf: 'Bölüm {{current}} / {{total}}',
    demoNote: 'Ekranlar örnek verilerle hazırlanmış bir canlandırmadır; gerçek bilgileriniz gösterilmez.',
    keyboard: 'Boşluk: oynat / duraklat · ← →: önceki / sonraki adım · M: sesi kapat / aç · F: tam ekran',
    oldGuide: 'Eski sistem kılavuzu (PDF)',
    close: 'Kılavuzu kapat',
    showTopics: 'Konuları göster',
    hideTopics: 'Konuları gizle',
    ended: 'Kılavuz bitti',
    endedText: 'Bir konuyu tekrar izlemek için soldaki listeden seçin.',
    replay: 'Baştan izle',
    controls: {
      seek: 'Video konumu',
      play: 'Oynat',
      pause: 'Duraklat',
      replay: 'Baştan oynat',
      prevChapter: 'Önceki bölüm',
      nextChapter: 'Sonraki bölüm',
      speed: 'Oynatma hızı',
      captionsOn: 'Altyazıyı kapat',
      captionsOff: 'Altyazıyı aç',
      mute: 'Sesi kapat',
      unmute: 'Sesi aç',
      volume: 'Ses düzeyi',
      voiceUnavailable: 'Tarayıcınız sesli anlatımı desteklemiyor',
      fullscreen: 'Tam ekran',
      exitFullscreen: 'Tam ekrandan çık',
    },
  },
  groups: {
    start: 'Başlarken',
    home: 'Ana Sayfa',
    profile: 'Profil sayfası',
    end: 'Kapanış',
  },
  chapters: {
    intro: 'Bu kılavuz nasıl kullanılır?',
    shell: 'Menü, arama ve üst çubuk',
    dashboard: 'Ana Sayfa',
    tasks: 'Görevlerim',
    projectsDialog: 'Projeler penceresi',
    reminders: 'Hatırlatmalar ve bildirimler',
    profileCard: 'Profil kartı ve bilgilerim',
    completion: 'Profil tamamlama',
    tabs: 'Profil bölümleri',
    calendar: 'Takvimim',
    agenda: 'Ajandam',
    files: 'Dosyalar',
    sop: 'SOP okuma',
    training: 'Eğitimler',
    myProjects: 'Projelerim',
    leaveRequest: 'İzin talebi',
    leaveList: 'İzin taleplerim',
    expenseRequest: 'Masraf talebi',
    expenseTrack: 'Masraf takip',
    messages: 'Mesajlar',
    announcements: 'Duyurular',
    bugReport: 'Hata bildir',
    cv: 'CV / GCP / IATA',
    end: 'Kapanış',
  },
  // Aramada eşleşen ek kelimeler (bölüm başlığı ve altyazılar da aranır)
  keywords: {
    intro: 'kılavuz rehber video nasıl kullanılır yardım',
    shell: 'menü kenar çubuğu arama ctrl k hall çıkış oturum tema koyu açık dil ingilizce zil oturum kapandı 10 dakika',
    dashboard: 'ana sayfa anasayfa dashboard hızlı erişim karşılama',
    tasks: 'görev yapılacaklar listesi iş durum tamamlandı gecikmiş öncelik zil',
    projectsDialog: 'proje projeler protokol merkez rapor excel detay hasta ziyaret',
    reminders: 'hatırlatma uyarı bildirim son tarih eksik belge mesaj bildirimi',
    profileCard: 'profil fotoğraf resim telefon acil durum adres ev iş çalıştığım il şehir şifre parola değiştir iletişim bilgileri',
    completion: 'profil tamamlama yüzde eksik bilgi halka',
    tabs: 'sekme bölüm menü kargolarım kargo',
    calendar: 'takvim vizit ziyaret iş ekle excel ay',
    agenda: 'ajanda google takvim etkinlik toplantı',
    files: 'dosya doküman form politika görev tanımı indir yazdır',
    sop: 'sop okudum anladım okuma onay sınav değerlendirme quiz',
    training: 'eğitim video sertifika sınav pop quiz final not yer imi',
    myProjects: 'projelerim vizit ziyaret pasif primer backup körleme excel',
    leaveRequest: 'izin yıllık mazeret rapor raporlu tatil bakiye gün yol izni talep',
    leaveList: 'izin taleplerim onay reddedildi beklemede durum',
    expenseRequest: 'masraf harcama fiş fatura pdf tutar kategori talep',
    expenseTrack: 'masraf takip düzenle reddedildi onaylandı neden',
    messages: 'mesaj sohbet yazışma dosya gönder emoji sesli görüntülü arama',
    announcements: 'duyuru bildirim haber',
    bugReport: 'hata bildir sorun ekran görüntüsü destek',
    cv: 'cv özgeçmiş gcp iata sertifika yükle şablon transcelerate bakanlık',
    end: 'son bitiş',
  },
  beats: {
    intro: 'Bu kılavuz, HabCare portalının yeni tasarımında günlük işlerinizi nasıl yapacağınızı gösterir: önce genel ekran ve Ana Sayfa, ardından Profil sayfasındaki tüm bölümler.',
    howTo: 'Videoyu baştan sona izlemeniz gerekmez. Soldaki listeden bir konu seçin, aramaya "izin" ya da "masraf" gibi bir kelime yazın veya alttaki adımlardan birine tıklayıp doğrudan o ana gidin.',
    shellSidebar: 'Soldaki menüden Ana Sayfa ve Profil sayfasına ulaşırsınız. Ana Sayfa’nın yanındaki oka basınca alt menü açılır; Yapılacaklar Listesi’ne buradan da gidebilirsiniz.',
    shellCollapse: 'Menünün kenarındaki küçük düğme menüyü daraltıp genişletir. Altta Hall ile sistem seçim ekranına döner, Çıkış Yap ile oturumu kapatırsınız. Telefonda menü, üst çubuktaki menü düğmesiyle açılır.',
    shellSearch: 'Üst çubuktaki arama kutusu menülerde arar; klavyede Ctrl + K ile de açılır. "Prof" yazmanız Profil’i bulmaya yeter, sonuca tıklayınca o sayfaya gidersiniz.',
    shellIcons: 'Sağdaki simgeler sırasıyla Hall, Ana Sayfa, size atanan yeni görevleri sayan zil, Türkçe / İngilizce dil seçimi ve açık / koyu temadır. Okunmamış mesaj ya da cevapsız arama olduğunda burada ayrıca bir simge belirir.',
    shellUser: 'Adınızın yazdığı düğme hesap menüsünü açar; buradan Profil sayfanıza gidebilir ya da çıkış yapabilirsiniz.',
    shellTimeout: 'Güvenliğiniz için portalda 10 dakika hiçbir işlem yapmazsanız oturumunuz kendiliğinden kapanır; yeniden giriş yapmanız yeterlidir. Bu kılavuz oynarken oturumunuz açık tutulur.',
    dashHero: 'Ana Sayfa’nın en üstünde, günün saatine göre sizi karşılayan kart yer alır. Portala girdiğinizde ilk gördüğünüz yer burasıdır.',
    dashTasks: 'Yapılacaklar Listesi kartı size atanan görevleri gösterir. Yeni bir görev geldiğinde kart kırmızıyla vurgulanır ve kaç yeni göreviniz olduğu yazar.',
    dashGuide: 'Bu kılavuz da Ana Sayfa’da durur. Büyük oynat düğmesi videoyu başlatır; yanındaki konu düğmeleri ise sizi doğrudan izin, masraf ya da dosyalar gibi bir bölüme götürür.',
    dashLinks: 'Hızlı erişim kartlarından Takvimim ve Duyurular, Profil’deki ilgili bölümü açar; Projelerim projeler penceresini açar. Kullanım Kılavuzu kartında eski sistemin PDF kılavuzu durmaya devam eder.',
    tasksOpen: 'Görevlerinizi görmek için Yapılacaklar Listesi kartındaki düğmeye ya da üst çubuktaki zile basın; Görevlerim penceresi açılır.',
    tasksStats: 'Üstteki kutular bekleyen, devam eden, tamamlanan ve gecikmiş görevlerinizi sayar. Altındaki düğmelerle listeyi Aktif, Tamamlanan veya Tümü olarak süzebilirsiniz.',
    tasksCard: 'Her kartta görevin başlığı, önceliği ve son tarihi bulunur. Soldaki renk önceliği gösterir; tarihi geçen görevler Gecikmiş, yeni gelenler Yeni etiketiyle işaretlenir.',
    tasksStatus: 'Bir göreve dokunduğunuzda açıklaması açılır. Durumu değiştir bölümünden görevi Devam Ediyor ya da Tamamlandı olarak işaretleyin; değişiklik hemen kaydedilir.',
    projOpen: 'Projelerim kartı, görev aldığınız projelerin listelendiği Projeler penceresini açar.',
    projFilter: 'Arama kutusuna proje kodu, protokol, müşteri ya da merkez yazarak listeyi daraltın. Görev ve proje durumuna göre süzebilir, üstteki düğmeyle atanan ve tüm projeler arasında geçebilirsiniz.',
    projDetail: 'Detay düğmesi projenin ayrıntılarını açar: protokol, müşteri ve tarihler, görev aldığınız merkezler ve rolünüz, ayrıca kendi hasta ve ziyaret özetiniz.',
    projReport: 'Rapor Çıktısı düğmesi, listede görünen projeleri Excel dosyası olarak indirir.',
    remLogin: 'Portala girdiğinizde bekleyen işleriniz varsa bir hatırlatma penceresi açılır: okumadığınız SOP’lar ve CV, GCP ya da IATA gibi eksik belgeleriniz burada listelenir.',
    remButtons: 'SOP’lara git ve Belgelerimi yükle düğmeleri sizi doğrudan ilgili bölüme götürür. Daha sonra’ya basarsanız pencere kapanır; işler tamamlanana kadar bir sonraki girişinizde yeniden hatırlatılır.',
    remBanner: 'Son tarihi yaklaşan SOP ya da eğitimleriniz varsa sayfanın üstünde kırmızı bir uyarı belirir. Tamamla düğmesi sizi Dosyalar bölümüne götürür.',
    remMessage: 'Yeni bir mesaj geldiğinde sağ altta bir bildirim kartı belirir; karta tıklayarak mesajı açabilirsiniz.',
    pcGo: 'Profil sayfasına soldaki menüden ya da sağ üstteki hesap menüsünden ulaşırsınız. Kılavuzun geri kalanı bu sayfayı anlatır.',
    pcOpen: 'Profil kartında fotoğrafınız, adınız, rolünüz ve bugünün tarihi yer alır. Sağ üstte profil tamamlama halkası ve Şifremi Değiştir düğmesi bulunur.',
    pcPhoto: 'Fotoğrafınızı değiştirmek için köşedeki kamera simgesine basıp bir resim seçin. Önizlemede profilde, kartlarda ve menüde nasıl görüneceğini kontrol edip Kaydet’e basın.',
    pcStats: 'Altındaki üç kutu kısa bir özettir: aktif proje sayınız, okuduğunuz SOP’lar ve okunmamış mesajlarınız.',
    pcContacts: 'İletişim bilgilerinizden acil durum telefonunu ve adreslerinizi kendiniz güncelleyebilirsiniz. Ekle ya da Düzenle’ye basın, numarayı yazın ve Kaydet’e basın.',
    pcAddress: 'Adres penceresinde ev adresi zorunlu, iş adresi isteğe bağlıdır. Hangisinin ana adresiniz olacağını yıldızlı düğmelerle seçin; çalıştığınız ili de listeden seçip kaydedin. Henüz bir projeniz yoksa bölge sorumlunuz takviminizi bu ile göre görür.',
    pcPassword: 'Şifremi Değiştir’e basın; mevcut şifrenizi ve iki kez yeni şifrenizi yazın. Yeni şifre en az 6 karakter olmalı ve iki alan aynı olmalıdır.',
    compRing: 'Profil tamamlama halkası profilinizin ne kadarının dolu olduğunu gösterir. Üzerine bastığınızda kişisel bilgiler, fotoğraf ve eğitimler için ayrı ayrı ilerleme görürsünüz.',
    compActions: 'Tamamlamak için listesindeki her satır sizi eksik işe götürür: fotoğraf, acil durum telefonu, ev adresi ya da bekleyen SOP ve eğitimler. Ad, rol veya e-posta gibi diğer bilgiler için yöneticinize başvurun.',
    tabsGroups: 'Sayfayı aşağı kaydırdığınızda bölüm menüsü üstte sabit kalır. Takvim, Dosyalar, Projelerim, İzin, Masraf, İletişim ve CV / GCP / IATA bölümleri buradadır.',
    tabsSub: 'Bazı bölümlerin alt sekmeleri vardır. Örneğin İzin’e bastığınızda altında İzin Talep Et ve İzin Taleplerim sekmeleri belirir.',
    tabsBadges: 'Bölüm adlarının yanındaki sayılar sizi bekleyen işleri gösterir: Dosyalar’da okunmamış dokümanlar, İletişim’de okunmamış mesajlar. Yetkiniz varsa ayrıca Kargolarım bölümü de görünür.',
    calOverview: 'Takvimim, vizitlerinizi ve işlerinizi ay görünümünde gösterir. Bir güne bastığınızda o günün planı sağdaki panelde listelenir.',
    calAdd: 'Vizit Ekle ve İş Ekle düğmeleriyle takviminize kayıt eklersiniz; Excel düğmesi takviminizi dosya olarak indirir.',
    calVideo: 'Takvimin ayrıntılı kullanımı için Nasıl okunur? açıklamasına ve Video rehber düğmesine bakın; vizit ekleme ve tamamlama orada adım adım anlatılır.',
    agOpen: 'Ajandam sekmesi, Google Takviminize hızlıca etkinlik eklemenizi sağlar.',
    agFill: 'Etkinlik başlığını, isterseniz bir açıklamayı ve başlangıç ile bitiş tarih ve saatini girin.',
    agSend: 'Google Takvime Ekle’ye bastığınızda Google Takvim bilgiler dolu olarak yeni sekmede açılır; etkinliği orada Kaydet’e basarak eklersiniz. Bu bölüm kendisi kayıt tutmaz.',
    filesCards: 'Dosyalar bölümünde size atanmış SOP’lar, eğitimler, formlar, politikalar ve görev tanımları kartlar halinde durur. Kartlardaki sayılar yeni ve okunmamış dokümanları gösterir.',
    filesOpen: 'Bir karta bastığınızda o kategorinin listesi aşağıda açılır. Yeni dokümanlar sarı zeminle ve Yeni etiketiyle en üstte görünür.',
    filesFilter: 'SOP listesini Okunmadı ya da Okundu olarak süzebilir, arama kutusuyla doküman adına göre arayabilirsiniz.',
    filesForms: 'Bir forma bastığınızda dosyası yeni sekmede açılır; oradan indirip yazdırabilirsiniz. Politikalar ve Görev Tanımları da aynı şekilde açılır.',
    sopOpen: 'Bir SOP’yi okumak için listede üzerine basın; doküman, görüntüleyicide açılır.',
    sopLock: 'Alttaki onay kutusu başta kilitlidir; doküman yüklendikten birkaç saniye sonra, videolarda ise izleme bitince açılır. Lütfen dokümanı sonuna kadar okuyun.',
    sopConfirm: '"Okudum ve anladım" kutusunu işaretlediğinizde departmanınıza özel kısa bir değerlendirme sınavı açılır.',
    sopQuiz: 'Soruları tek tek cevaplayıp Sonraki ile ilerleyin. Geçme notunun altında kalırsanız dokümanı yeniden gözden geçirip yeni sorularla tekrar deneyebilirsiniz.',
    sopDone: 'Sınavı geçtiğinizde SOP, Okundu olarak işaretlenir ve okunmamışlar listesinden çıkar.',
    trList: 'Eğitimler kartında video eğitimleriniz listelenir. Son katılım tarihi olanlar tarihleriyle, tamamladıklarınız Tamamlandı, süresi geçenler Süre doldu etiketiyle görünür.',
    trPlayer: 'Eğitim kendi oynatıcısında açılır ve kaldığınız yerden devam eder. Henüz izlemediğiniz kısımlara atlanamaz; sağda bölümleri, notlarınızı ve yer imlerinizi görürsünüz.',
    trPop: 'İzlerken arada Pop Quiz soruları çıkar. Doğru cevaplayınca devam edersiniz; yanlış cevapta o bölümü tekrar izlemeniz istenir.',
    trExam: 'Videonun neredeyse tamamını izlediğinizde Final sınavı açılır. Sınavı geçince sertifikanızı görüntüleyip eğitimi tamamlarsınız.',
    mpCards: 'Projelerim bölümünde görev aldığınız projeler kartlar halinde görünür: kodu, adı, primer ya da backup oluşunuz ve körleme durumunuz. Pasif projeleri sağ üstteki düğmeyle gizleyebilirsiniz.',
    mpVisits: 'Bir projeye dokunduğunuzda o projedeki vizitleriniz açılır. Başlangıç ve bitiş tarihi seçerek listeyi daraltabilirsiniz.',
    mpDetail: 'Tamamlanan bir vizitin ayrıntılarını Detay ile açarsınız. Excel İndir, ekranda görünen vizitleri dosya olarak indirir.',
    lrType: 'İzin talebi için İzin bölümüne gidin. İzin Talep Et sekmesinde önce izin türünü seçin; her türün altında kısa bir açıklama bulunur.',
    lrBalance: 'Yıllık izinde bakiyeniz gösterilir: toplam hakkınız, kullandığınız, onay bekleyen ve kalan gün sayısı.',
    lrDates: 'Başlangıç ve bitiş tarihini seçin. İzin süresi kendiliğinden hesaplanır: cumartesi yarım gün sayılır, pazar ve resmi tatiller sayılmaz.',
    lrMore: 'Varsa yol süresini girin; yarım gün de yazabilirsiniz. İzin nedenini ve izinde bulunacağınız adresi ekleyin. Raporlu izinde rapor dosyanızı da ekleyebilirsiniz.',
    lrSend: 'İzin Talebini Gönder’e basın. Talebiniz yöneticinizin onayına gider; onaylandığında takviminize de işlenir.',
    llList: 'İzin Taleplerim sekmesinde gönderdiğiniz tüm talepler tarihleri, süresi ve durumuyla listelenir.',
    llFilter: 'Üstteki düğmelerle Beklemede, Onaylandı ya da Reddedildi durumundaki talepleri ayrı ayrı görebilirsiniz.',
    llNote: 'Yöneticiniz bir not eklediyse talebin altında görünür; reddedilen taleplerde reddetme nedenini buradan okursunuz.',
    erForm: 'Masraf bölümünde Masraf Talep Et sekmesine gidin. Tutarı, kategoriyi ve harcamanın ne için, nerede, ne zaman yapıldığını yazın.',
    erDocs: 'Fiş ve faturalarınızı PDF olarak ekleyin. Birden fazla dosya seçebilirsiniz; her biri en fazla 10 MB olmalıdır.',
    erSend: 'Masraf Talebini Gönder’e basın. Talebiniz finans yöneticilerine iletilir; durumunu Masraf Takip sekmesinden izlersiniz.',
    etList: 'Masraf Takip sekmesinde toplam, bekleyen, onaylanan ve reddedilen taleplerinizi görürsünüz. Her kartta tutar, kategori, açıklama ve belgeler bulunur.',
    etEdit: 'Henüz onaylanmamış bir talebi Düzenle ile değiştirebilirsiniz: tutarı ve açıklamayı güncelleyebilir, belgeleri değiştirebilirsiniz.',
    etRejected: 'Reddedilen taleplerde reddedilme nedeni kartın üzerinde yazar. Eksiği tamamlayıp yeni bir talep oluşturabilirsiniz.',
    msgOpen: 'Mesajlar, İletişim bölümündedir. Sayfanın hızlı açılması için mesajlar siz Mesajları Aç’a bastığınızda yüklenir.',
    msgPick: 'Soldaki listede arama yaparak çalışma arkadaşınızı bulun ve üzerine basın. Okunmamış mesajlar sayıyla gösterilir.',
    msgSend: 'Mesajınızı alttaki kutuya yazıp gönder düğmesine basın. Emoji eklemek için mesaj kutusunun üstündeki emojileri kullanabilirsiniz.',
    msgFile: 'Ataç simgesiyle bir dosya ya da fotoğraf seçip gönderebilirsiniz; dosya sohbette görünür ve karşı taraf indirebilir.',
    msgCall: 'Sağ üstteki düğmelerle sesli ya da görüntülü görüşme başlatırsınız. Kaçırdığınız aramalar üst çubukta Cevapsız aramalar olarak görünür.',
    annList: 'Bildirimler sekmesinde şirket genelindeki duyurular yer alır; en yeni duyuru en üsttedir. Ana Sayfa’daki Duyurular kartı da sizi doğrudan buraya getirir.',
    bugForm: 'Portalda bir hatayla karşılaşırsanız İletişim bölümündeki Hata Bildir sekmesini kullanın. Ne yapmaya çalışırken, hangi sayfada ve ne olduğunu yazın.',
    bugShot: 'Bir ekran görüntüsü eklemek sorunun çok daha hızlı çözülmesini sağlar. Bildirimi Gönder’e bastığınızda yazılım ekibine iletilir.',
    cvTabs: 'CV / GCP / IATA bölümünde Türkçe CV, İngilizce CV, GCP ve IATA belgeleriniz için ayrı sekmeler bulunur.',
    cvTemplate: 'Türkçe CV için Bakanlık Özgeçmiş Formu’nu, İngilizce CV için TransCelerate şablonunu buradan indirip doldurabilirsiniz.',
    cvUpload: 'Dosyanızı seçin ya da alana sürükleyin: PDF, DOC veya DOCX, en fazla 10 MB. Yükle’ye bastığınızda dosya soldaki listede görünür.',
    cvReplace: 'Yüklediğiniz dosyayı görüntüleyebilir, indirebilir ya da silebilirsiniz. CV ve GCP’de tek dosya tutulur; yenilemek için önce eskisini silin. IATA’ya birden fazla dosya yükleyebilirsiniz.',
    end: 'Hepsi bu kadar! Bir konuyu tekrar görmek istediğinizde bu kılavuzu Ana Sayfa’dan açıp konu listesinden ya da aramadan doğrudan ilgili bölüme gidebilirsiniz.',
  },
  // Canlandırmadaki örnek içerikler
  stage: {
    introText: 'Yeni portalda günlük işlerinizi adım adım öğrenin.',
    howtoTitle: 'Aradığınızı hemen bulun',
    howtoTopics: 'Konu seçin',
    howtoSearch: 'Arayın',
    howtoSteps: 'Adıma atlayın',
    howtoQuery: 'izin',
    howtoStep1: 'İzin türünü seçin',
    howtoStep2: 'Tarihleri girin',
    howtoStep3: 'Talebi gönderin',
    endTitle: 'Hazırsınız!',
    endText: 'Kılavuz her zaman Ana Sayfa’da. Takıldığınız bir konuya istediğiniz an geri dönebilirsiniz.',
    deadlineTitle: 'Son tarihi yaklaşan 2 atamanız var',
    deadlineItems: 'SOP-014 Bilgilendirilmiş Onam · 2 gün kaldı  ·  İyi Klinik Uygulamalar Eğitimi · 6 gün kaldı',
    complete: 'Tamamla',
    messagePreview: 'Yarınki vizit için numune kitlerini hazırladım 👍',
    messagePreview2: 'Toplantı notlarını paylaştım.',
    messagePreview3: 'Teşekkürler, görüşmek üzere!',
    myMessage: 'Harika, teşekkürler! Sabah 9’da merkezde olacağım.',
    task1: 'Merkez dosyasını güncelle',
    task1Desc: 'Haziran vizitlerine ait kaynak dokümanları merkez dosyasına ekleyin ve eksikleri proje yöneticisine bildirin.',
    task2: 'GCP sertifikasını yenile',
    task3: 'Aylık vizit raporunu gönder',
    p1: 'Onkoloji Faz III Çalışması',
    p2: 'Kardiyoloji Gözlemsel Çalışma',
    p3: 'Nöroloji Faz II Çalışması',
    center: 'Ankara Üniversite Hastanesi',
    sop1: 'Bilgilendirilmiş Onam Süreci',
    sop2: 'Numune Gönderimi',
    sop3: 'Advers Olay Bildirimi',
    training1: 'İyi Klinik Uygulamalar (GCP)',
    training2: 'Veri Gizliliği ve KVKK',
    training3: 'Numune Kiti Hazırlama',
    training4: 'Yıllık İSG Eğitimi',
    form1: 'Vizit Kontrol Formu',
    form2: 'Numune Gönderim Formu',
    quizQuestion: 'Bilgilendirilmiş onam formu hangi aşamada imzalatılmalıdır?',
    quizChoice1: 'İlk vizitten sonra',
    quizChoice2: 'Çalışmaya özgü herhangi bir işlemden önce',
    quizChoice3: 'Randomizasyondan sonra',
    quizChoice4: 'Çalışma bittiğinde',
    popQuestion: 'GCP’ye göre çalışma kayıtları kimin denetimine açık olmalıdır?',
    popChoice1: 'Yalnızca sponsorun',
    popChoice2: 'Monitör, denetçi ve yetkili otoritelerin',
    popChoice3: 'Hiç kimsenin',
    dayTitle: 'Bugünün planı',
    plannedToday: 'Planlananlar',
    agendaTitle: 'Proje toplantısı',
    agendaDesc: 'Aylık durum değerlendirmesi',
    leaveReason: 'Aile ziyareti',
    homeAddress: 'Kızılay Mah. Atatürk Blv. No:12, Çankaya / Ankara',
    noteApproved: 'İyi tatiller!',
    noteRejected: 'Aynı tarihlerde merkezde monitör vizitimiz var; başka bir gün planlayalım.',
    expenseDesc: 'Merkez vizit ulaşımı (taksi)',
    expenseDesc2: 'İzmir vizit konaklaması',
    expenseDesc3: 'Toplantı yemeği',
    expenseReject: 'Fiş okunmuyor, lütfen net bir kopya ekleyin.',
    announcement1: 'Ofisimiz 29 Ekim Cumhuriyet Bayramı nedeniyle kapalı olacaktır.',
    announcement2: 'Yeni portal yayında! Ana Sayfa’daki kılavuzdan kullanımını izleyebilirsiniz.',
    announcement3: 'Yıllık GCP eğitimleri Kasım ayında başlıyor.',
    bugText: 'Masraf talebinde PDF eklerken "Gönder"e basınca sayfa yanıt vermiyor.',
  },
};

export default userGuide;
